import { createAppTranslation } from '@fiverr-private/i18n-react';
import copies from '../../copies.json';
import { DEPARTMENT_KEYS } from '../../lib/comeet';

export const { appTranslate, AppI18n, hasAppTranslation } = createAppTranslation(copies, 'careers_page_perseus');

export const departmentLabel = (raw: string): string => {
    const slug = DEPARTMENT_KEYS[raw];
    if (!slug) {
        return raw;
    }
    const key = `open_positions.departments.${slug}`;
    return hasAppTranslation(key) ? (appTranslate(key) as string) : raw;
};
